export const ALMANAC_DATA_CHANGED = 'almanac:data-changed';

/** Notify existing page-local data loaders after a confirmed assistant write. */
export function notifyAlmanacDataChanged(toolName: string): void {
  window.dispatchEvent(new CustomEvent(ALMANAC_DATA_CHANGED, { detail: { toolName } }));
}
